import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VesTransactionItem } from 'src/app/dashboard/services/ves-transactions.service';

@Component({
  selector: 'app-detail-transaction-modal',
  templateUrl: './detail-transaction-modal.component.html',
  styleUrls: ['./detail-transaction-modal.component.sass']
})
export class DetailTransactionModalComponent {
  transaction: VesTransactionItem;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: VesTransactionItem,
    private dialogRef: MatDialogRef<DetailTransactionModalComponent>,
  ) {
    this.transaction = data;
  }

  close(): void {
    this.dialogRef.close();
  }

  formatVES(amount: number | null): string {
    if (amount === null) return '-';
    return new Intl.NumberFormat('es-VE', {
      style: 'currency',
      currency: 'VES',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('es-VE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/Caracas',
    }).format(date);
  }

  getStatusColor(status: string): string {
    switch (status?.toLowerCase()) {
      case 'completed':
      case 'completado':
        return '#16a34a';
      case 'pending':
      case 'pendiente':
        return '#ea580c';
      case 'rejected':
      case 'rechazado':
      case 'failed':
      case 'fallido':
        return '#dc2626';
      default:
        return '#6b7280';
    }
  }

  getTypeLabel(type: string): string {
    switch (type) {
      case 'SWAP_USDT_VES': return 'Swap USDT→VES';
      case 'CREDITO_MANUAL':
      case 'MANUAL_CREDIT': return 'Crédito Manual';
      case 'DEBITO_MANUAL':
      case 'MANUAL_DEBIT': return 'Débito Manual';
      case 'COMPRA_USDT': return 'Compra USDT';
      case 'COMPRA_USDT_VES': return 'Compra USDT (VES)';
      case 'RETIRO_USDT': return 'Retiro USDT';
      case 'RETIRO_USDT_VES': return 'Retiro USDT (VES)';
      case 'RETIRO_VES': return 'Retiro VES';
      case 'REVERSO_RETIRO_VES': return 'Reverso Retiro VES';
      case 'ENVIO_VES_BENEFICIARIO': return 'Envío VES Beneficiario';
      default: return type;
    }
  }
}
